import { Injectable } from '@angular/core';
import { ApiHttpService } from '../../../shared/services/api_http.service';
import { Observable } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';

@Injectable()
export class FeatureService {
  constructor(private http: ApiHttpService) {}

  getFeaturesData(): Observable<Array<any>> {
    return this.http.get('apps/:app_key/features').pipe(
      map((data: any) => data.response.features)
    );
  }

  getFeatureSettings(featureName): Observable<any> {
    return this.getFeaturesData().pipe(
      map((response: any) => response.find((feature) => feature.name === featureName)),
      mergeMap((featureData: any) => this.http.get('apps/:app_key/features/' + featureData.id + '/feature_settings'))
    );
  }

  setFeatureSettings(featureName, params): Observable<any> {
    return this.getFeaturesData().pipe(
      map((response: any) => response.find((feature) => feature.name === featureName)),
      mergeMap((featureData: any) =>
        this.http.put('apps/:app_key/features/' + featureData.id + '/feature_settings/mass_update', params))
    );
  }

  resetFeatureSettings(featureName, params): Observable<any> {
    return this.getFeaturesData().pipe(
      map((response: any) => response.find((feature) => feature.name === featureName)),
      mergeMap((featureData: any) =>
        this.http.put('apps/:app_key/features/' + featureData.id + '/feature_settings/reset_all_settings', params))
    );
  }

  hasFeature(featureName): Observable<boolean> {
    return this.getFeaturesData().pipe(
      map((response: any) => response.find((feature) => feature.name === featureName) != null)
    );
  }

  getFeatures(): Observable<any> {
    return this.getFeaturesData().pipe(
      map((features: any) => features.reduce((accumulatedFeatures, feature) => {
        accumulatedFeatures[feature.name] = true;
        return accumulatedFeatures;
      }, {}))
    );
  }

  isFeatureEnabled(featureName): Observable<boolean> {
    return this.getFeaturesData().pipe(
      map((response: any) => response.find((feature) => {
        return feature.name === featureName && feature.user_enabled;
      }) != null)
    );
  }

  getEnabledFeatures(): Observable<any> {
    return this.getFeaturesData().pipe(
      map((response: any) => response.filter((feature) => feature.user_enabled)),
      map((features: any) => features.reduce((accumulatedFeatures, feature) => {
        accumulatedFeatures[feature.name] = true;
        return accumulatedFeatures;
      }, {}))
    );
  }

  updateUserEnabled(featureName, userEnabled): Observable<any> {
    return this.getFeaturesData().pipe(
      map((response: any) => response.find((feature) => {
        return feature.name === featureName;
      })),
      mergeMap((featureData: any) =>
        this.http.put('apps/:app_key/features/' + featureData.id, {feature: {user_enabled: userEnabled}})
      )
    );
  }

  resetAllFeatureSettings(featureName): Observable<any> {
    return this.getFeaturesData().pipe(
      map((response: any) => response.find((feature) => feature.name === featureName)),
      mergeMap((featureData: any) => this.http.put('apps/:app_key/features/' + featureData.id + '/feature_settings/reset_all_settings'))
    );
  }
}
